import fetchServer from "../controllers/fetchServer";

const buildReportQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      searchParams.set(key, value);
    }
  });

  const queryString = searchParams.toString();

  return queryString ? `?${queryString}` : "";
};

export const getSummaryMetrics = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/report/summary-metrics${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};

export const getRevenueTrends = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/report/revenue-trends${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};

export const getTopRevenueAgents = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/report/top-revenue-agents${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};

export const getRevenueBycategory = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/report/revenue-by-category${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};

export const getFlightRevenueByAirline = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/report/flight-revenue-by-airline${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};
export const getRevenueByGeography = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/report/revenue-by-geography${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};
export const getSubscriptionReport = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/payment/v1/report/subscription${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};
// flight report
export const getFlightSummaryMetrics = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/report/summary-metrics${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};

export const getFlightRevenueTrends = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/report/revenue-trends${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};

export const getFlightRevenueStreams = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/report/revenue-streams${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};

export const getFlightTopRoutes = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/report/top-routes${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};
export const getFlightPostTicketingFees = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/report/post-ticketing-fees${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};

export const getRevenueByClass = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/report/revenue-by-class${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};

// Top airlines
export const getTopAirlines = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/report/top-airlines${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching executive summary",
    );
  }

  return res.data || res;
};

export const getHotelSummaryMetrics = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/hotels/summary${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching hotel summary",
    );
  }

  return res.data || res;
};

export const getHotelRevenueStreams = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/hotels/revenue-streams${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching hotel revenue streams",
    );
  }

  return res.data || res;
};

export const getHotelRevenueTrends = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/hotels/revenue-trends${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching hotel revenue trends",
    );
  }

  return res.data || res;
};

export const getHotelBreakdowns = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/hotels/breakdowns${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching hotel breakdowns",
    );
  }

  return res.data || res;
};

export const getHotelRankings = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/hotels/rankings${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching hotel rankings",
    );
  }

  return res.data || res;
};

export const getPackageSummaryMetrics = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/packages/summary${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching package summary",
    );
  }

  return res.data || res;
};

export const getPackageRevenueStreams = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/packages/revenue-streams${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching package revenue streams",
    );
  }

  return res.data || res;
};

export const getPackageRevenueTrends = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/packages/revenue-trends${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching package revenue trends",
    );
  }

  return res.data || res;
};

export const getPackageBreakdowns = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/packages/breakdowns${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching package breakdowns",
    );
  }

  return res.data || res;
};

export const getPackageRankings = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/packages/rankings${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching package rankings",
    );
  }

  return res.data || res;
};

export const getInsuranceSummaryMetrics = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/insurances/summary${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching insurance summary",
    );
  }

  return res.data || res;
};

export const getInsuranceRevenueStreams = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/insurances/revenue-streams${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching insurance revenue streams",
    );
  }

  return res.data || res;
};

export const getInsuranceRevenueTrends = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/insurances/revenue-trends${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching insurance revenue trends",
    );
  }

  return res.data || res;
};

export const getInsuranceBreakdowns = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/insurances/breakdowns${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching insurance breakdowns",
    );
  }

  return res.data || res;
};

export const getInsuranceRankings = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/insurances/rankings${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching insurance rankings",
    );
  }

  return res.data || res;
};

export const getNobiPackageSummaryMetrics = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/nobi-packages/summary${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching Nobi package summary",
    );
  }

  return res.data || res;
};

export const getNobiPackageRevenueStreams = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/nobi-packages/revenue-streams${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching Nobi package revenue streams",
    );
  }

  return res.data || res;
};

export const getNobiPackageRevenueTrends = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/nobi-packages/revenue-trends${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching Nobi package revenue trends",
    );
  }

  return res.data || res;
};

export const getNobiPackageBreakdowns = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    url: `/product/v1/other-reports/nobi-packages/breakdowns${buildReportQueryString(
      params,
    )}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching Nobi package breakdowns",
    );
  }

  return res.data || res;
};

export const getNobiPackageRankings = async (params = {}) => {
  const endpoints = [
    "/product/v1/other-reports/nobi-packages/rankings",
    "/product/v1/other-reports/hotels/rankings",
  ];

  let lastError;

  for (const url of endpoints) {
    const res = await fetchServer({
      method: "GET",
      url: `${url}${buildReportQueryString(params)}`,
    });

    if (!res || res.error) {
      lastError = res?.error;
      continue;
    }

    const payload = res.data || res;
    const looksLikeNobiPackageRanking =
      payload?.message?.toLowerCase?.().includes("nobi package") ||
      payload?.data?.topPartners?.some((item) => item?.packageName);

    if (looksLikeNobiPackageRanking) {
      return payload;
    }
  }

  throw new Error(
    lastError || "Something went wrong fetching Nobi package rankings",
  );
};

export const getNobiPackageCategories = async () => {
  const res = await fetchServer({
    method: "GET",
    url: "/product/v1/nobiPackage/categories",
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching Nobi package categories",
    );
  }

  return res.data || res;
};

// wallet response
export const getWalletSummary = async () => {
  const res = await fetchServer({
    method: "GET",
    url: "/payment/v1/report/wallet-summary",
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching wallet summary",
    );
  }

  return res.data || res;
};

// wallet activity trends
export const getWalletActivityTrends = async () => {
  const res = await fetchServer({
    method: "GET",
    url: "/payment/v1/report/wallet-activity-trend",
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching wallet activity trends",
    );
  }

  return res.data || res;
};

// Wallet transaction distribution
export const getWalletTransactionDistribution = async () => {
  const res = await fetchServer({
    method: "GET",
    url: "/payment/v1/report/wallet-transaction-distribution",
  });

  if (!res || res.error) {
    throw new Error(
      res?.error ||
        "Something went wrong fetching wallet transaction distribution",
    );
  }

  return res.data || res;
};

// Wallet top holders
export const getWalletTopHolders = async () => {
  const res = await fetchServer({
    method: "GET",
    url: "/payment/v1/report/wallet-top-holders",
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching wallet top holders",
    );
  }

  return res.data || res;
};

// Wallet high value activity
export const getWalletHighValueActivity = async () => {
  const res = await fetchServer({
    method: "GET",
    url: "/payment/v1/report/wallet-high-value-activity",
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching wallet high value activity",
    );
  }

  return res.data || res;
};

// Agent wallet analytics
export const getAgentWalletAnalytics = async () => {
  const res = await fetchServer({
    method: "GET",
    url: "/payment/v1/report/agent-wallet-analytics",
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching agent wallet analytics",
    );
  }

  return res.data || res;
};

// get transaction trends
export const getTransaction = async (params = {}) => {
  const res = await fetchServer({
    method: "GET",
    // url: "/payment/v2/transaction/transactions?filterBy=reason,paymentMode,status&filterValue=IssueTicket,Cash,Success",
    url: `/payment/v2/transaction/transactions${buildReportQueryString(params)}`,
  });

  if (!res || res.error) {
    throw new Error(
      res?.error || "Something went wrong fetching transaction data",
    );
  }

  return res.data || res;
};
